var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.608 12.783c0.639-1.52 2.652-6.383 2.652-7.414v-4.055h-13.637v4.055c0 1.034 2 5.927 2.624 7.428-3.106 1.546-5.246 4.743-5.246 8.448 0 5.214 4.227 9.441 9.441 9.441s9.441-4.227 9.441-9.441c-0-3.717-2.153-6.923-5.275-8.463zM3.671 5.368v-3.006h5.227v7.177h1.049v-7.177h5.264v3.006c0 0.575-1.287 3.96-2.569 7.004-1.001-0.361-2.075-0.568-3.2-0.568-1.136 0-2.221 0.211-3.23 0.579-1.090-2.624-2.54-6.383-2.54-7.015zM9.441 29.637c-4.627 0-8.392-3.765-8.392-8.392s3.765-8.392 8.392-8.392c4.627 0 8.392 3.765 8.392 8.392s-3.765 8.392-8.392 8.392z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.441 14.951c-3.476 0-6.294 2.818-6.294 6.294s2.818 6.294 6.294 6.294c3.477 0 6.294-2.818 6.294-6.294s-2.817-6.294-6.294-6.294zM9.441 26.49c-2.892 0-5.245-2.353-5.245-5.245s2.353-5.245 5.245-5.245c2.893 0 5.245 2.353 5.245 5.245s-2.352 5.245-5.245 5.245z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.aa7c67e2129a093c58a17e816e07e60f.svg";
export { ForwardRef as ReactComponent };